import './bootstrap';
$('body').on('click', '.row-clickable td:not(.ignore-click)', function(e) {
    var target = $(this).parent().data('href');

    if (target) {
        window.document.location = target ;
    }
});
